<form [formGroup]="formGroup" class="new-search-fields-form">
    <div class="row mb-3 new-search-fields-form__row" *ngFor="let row of rows">
        <label class="col-sm-2 new-search-fields-form__label" for="title">{{ row.name | translate }}</label>
        <div class="col-sm-2">
            <ng-select class="new-search-fields-form__select"
                [formControlName]="row.formControlName + 'Operation'"
                [clearable]="false" [searchable]="false">
                <ng-option *ngFor="let p of row.operator.options" [value]="p.value">{{ p.name | translate }}</ng-option>
            </ng-select>
        </div>
        <div class="col-sm-3">
            <input *ngIf="row.value.type=='text'" type="text" class="form-control new-search-fields-form__input"
                [formControlName]="row.formControlName">
            <ng-select *ngIf="row.value.type=='select'" class="new-search-fields-form__select"
                [formControlName]="row.formControlName"
                [clearable]="false" [searchable]="(row.value.options?.length || 0) > 8">
                <ng-option *ngFor="let p of row.value.options" [value]="p.value">{{ p.name | translate }}</ng-option>
            </ng-select>
            <input *ngIf="row.value.type=='datePicker'" mwlFlatpickr [mode]="row.value.mode" [altInput]="true"
                [convertModelValue]="false" [altInputClass]="'datetime'" [clickOpens]="row.value.clickOpens"
                [formControlName]="row.formControlName" class="form-control new-search-fields-form__input" />

        </div>
        <div class="col-sm-1 add-row">
            <button *ngIf="!isDeletable(row)" (click)="addNewRow(row)" type="button"
                class="gray-button new-search-fields-form__row-button">
                +
            </button>
            <button *ngIf="isDeletable(row)" type="button" (click)="removeRow(row)"
                class="red-button new-search-fields-form__row-button">
                x
            </button>
        </div>
    </div>
</form>